import React, { ElementType } from 'react';

import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from './index.scss';

const RecipesTitle = ({ value, headingLevel }: { value: string; headingLevel: number }) => (
  <div data-testid="recipes-title">
    <Typography
      secondaryLegacy={{
        font: 'sebenta',
      }}
      textStyle="heading-xl"
      component={`h${headingLevel}` as ElementType}
      className={styles.h1}
    >
      {value}
    </Typography>
  </div>
);

RecipesTitle.displayName = 'RecipesTitle';

export default RecipesTitle;
